<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="Instructions-topCurve-wrapper lxn-w100">
      <CustomCurve>
        <TopNav @rightTextClick="addInstruction" v-if="$store.getters.language.texts.isRTL" :rightText="$store.getters.language.texts.Instructions_addInstruction" rightIcon="plus" centerText=""></TopNav>
        <TopNav @leftTextClick="addInstruction" v-else rightText="" :leftText="$store.getters.language.texts.Instructions_addInstruction" leftIcon="plus" centerText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="Instructions-main-wrapper lxn-pos-rel">
      <div class="Instructions-wrapper-main-instructions lxn-margin-auto lxn-border-round lxn-pos-rel lxn-overflow-hidden">
        <div v-if="instructions.length === 0" class="Instructions-wrapper-noInstructions lxn-text-center" :class="[$store.getters.language.directionClass, $store.getters.language.font]">
          {{$store.getters.language.texts.Instructions_noInstruction}}
        </div>
        <div v-for="(instruction, index) in instructions" :key="index" class="Instructions-wrapper-instructions lxn-w100 lxn-border-round lxn-overflow-hidden">
          <div class="Instructions-wrapper-colorBar lxn-h100" :class="$store.getters.language.floatClass" :style="colorBar(index)">
          </div>
          <div class="Instructions-Instruction-icon lxn-h100" :class="$store.getters.language.floatClass">
            <ButtonIcon :size="40" bgColor="#53636C" icon="instruction" iconColor="#FFFFFF" :padding="8" />
          </div>
          <div class="Instructions-wrapper-Instruction-text lxn-h100" :class="$store.getters.language.floatClass">
            <div class="Instructions-Instruction-text lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{instruction.name}}
            </div>
            <div class="Instructions-Instruction-text lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.getHubByUUID(instruction.hubUUID).name}}
            </div>
          </div>
          <div class="Instructions-Instruction-setting lxn-h100" :class="$store.getters.language.floatClass">
            <ButtonIcon @click="editInstruction(index)" :size="50" bgColor="#1EA5DE" icon="cog" iconColor="#FFFFFF" :padding="8" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'Instructions',
  components: {
    CustomCurve,
    TopNav,
    ButtonIcon
  },
  mounted: function () {
    this.$store.commit('setAppBusy', true);
    setTimeout(() => {
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        this.getHubInstructions(i)
      }
    }, 2000)
  },
  destroyed: function () {
  },
  data: function () {
    return {
      instructions: []
    }
  },
  methods: {
    openMenu: function () {
      this.$root.openMenu();
    },
    addInstruction: function () {
      this.$router.push('/addInstruction');
    },
    editInstruction: function (index) {
      this.$router.push('/editInstruction/' + this.instructions[index].instructionId);
    },
    colorBar: function (index) {
      return "background-color: " + this.$store.state.themeMainColors[this.instructions[index].color] + ";";
    },
    getHubInstructions: function (hubIndex) {
      const hub = this.$store.state.hubs[hubIndex];
      const psk = hub.psk;
      const destinationUUID = hub.uuid;
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: psk,
        destinationUUID: destinationUUID,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('readHubInstructions', {
        messagingHook: messagingHook,
        hubUUID: destinationUUID,
      })
      .then(response => {
        const instructions = response.body.bodyContent.instructionList.filter(x => x.instructionId >= 20000 && x.instructionId <= 29999);
        let instructionState = this.$store.state.instructions;
        instructions.filter(x => !instructionState.map(s => s.instructionId).includes(x.instructionId)).forEach(x => {
          this.$store.commit('addInstruction', {
            name: this.$store.getters.language.texts.Instruction_CommonName,
            color: 0,
            hubUUID: hub.uuid,
            instructionId: x.instructionId,
          });
        });
        instructionState.filter(x => !instructions.map(s => s.instructionId).includes(x.instructionId)).forEach(x => {
          this.$store.commit('deleteInstruction', x.instructionId);
        });
        this.$store.commit('saveState');
        instructionState = this.$store.state.instructions;
        this.instructions = instructions.map(x => {
          return instructionState.find(s => s.instructionId === x.instructionId);
        });
        this.$store.commit('setAppBusy', false);
        this.$store.commit('saveState');
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);
      });
    }
  }
}
</script>

<style>
  .Instructions-topCurve-wrapper {
    height: 150px;
  }
  .Instructions-main-wrapper {
    margin-top: -100px;
    margin-bottom: 14px;
    z-index: 2;
  }
  .Instructions-wrapper-noInstructions {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .Instructions-wrapper-main-instructions {
    width: calc(100% - 36px);
    background-color: #ffffff;
    padding: 10px;
    padding-bottom: 0;
    z-index: 1;
    margin-bottom: 14px;
  }
  .Instructions-wrapper-instructions {
    height: 50px;
    background-color: #ECECEC;
    margin-bottom: 14px;
  }
  .Instructions-wrapper-instructions:first-child {
    margin-top: 4px;
  }
  .Instructions-Instruction-icon {
    width: 50px;
    padding: 5px;
  }
  .Instructions-wrapper-colorBar {
    width: 8px;
  }
  .Instructions-wrapper-Instruction-text {
    width: calc(100% - 108px);
  }
  .Instructions-Instruction-text {
    height: 25px;
    line-height: 25px;
    padding-left: 5px;
    padding-right: 5px;
    color: #52626C;
  }
  .Instructions-Instruction-setting {
    width: 50px;
  }
</style>